
import React from 'react';
import { ReactNode } from 'react';
import Footer from './Footer';
import Nav from './Nav';

interface Props {
  children: ReactNode;
}

const Main = ({  children }: Props) => {  
  return (
    <div className="w-full flex-1 flex-col ">
      <Nav />

      <div className="min-h-screen mx-auto pt-24">
        <main>{children}</main>
      </div>

      <Footer />
    </div>
  );
}

export default Main;
